import axios from "axios";
import { baseURL } from "../globals/constants";

// Beskeder på admins egen enhed (PWA). Fejler et kald, sker der ingenting - admin virker som før.
const authHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` } });

export const getPushStatus = async (): Promise<{ enabled: boolean; devices: number } | null> => {
  try {
    return (await axios.get(`${baseURL}/v1/push/status`, authHeaders())).data;
  } catch {
    return null;
  }
};

export const getPushKey = async (): Promise<{ enabled: boolean; publicKey: string } | null> => {
  try {
    return (await axios.get(`${baseURL}/v1/push/key`, authHeaders())).data;
  } catch {
    return null;
  }
};

export const subscribeToPush = async (subscription: any) => axios.post(`${baseURL}/v1/push/subscribe`, { subscription }, authHeaders());

export const unsubscribeFromPush = async (endpoint: string) => axios.post(`${baseURL}/v1/push/unsubscribe`, { endpoint }, authHeaders());

export const sendPushTest = async () => axios.post(`${baseURL}/v1/push/test`, {}, authHeaders());
